import { ReactNode, forwardRef, Children } from 'react'
import { Divider, styled } from '@mui/material'

const Container = styled('div')`
  width: 100%;
  z-index: 2;
  top: 0;
`
const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface PropTypes {
  hasAnyChild: boolean
  isStatic?: boolean
  children: ReactNode
}
export const TopBarsContainer = forwardRef(
  ({ hasAnyChild, isStatic, children }: PropTypes, ref: any) => {
    return (
      <Container
        ref={ref}
        style={{
          position: isStatic ? 'static' : 'absolute',
          filter: hasAnyChild
            ? 'drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15))'
            : undefined,
        }}
      >
        {!hasAnyChild
          ? null
          : Children.map(children, item => {
              return (
                <>
                  {item}
                  {item && <StyledDivider sx={{ borderColor: 'neutral200' }} />}
                </>
              )
            })}
      </Container>
    )
  },
)

TopBarsContainer.defaultProps = {
  isStatic: false,
}
